import { find } from 'lodash-es'
import { PlatformCode } from '@/types/schema/platform/platform-code-schema'
import { Platform, platforms } from '@/types/schema/platform/platform-schema'

export const convertPlatformCodeFromZodPlatformCode = (
  code: PlatformCode,
): Platform | undefined => {
  return find(platforms, { code })
}
